// @ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { errorToast, successToast } from 'utils/toastHandler';
import {
  createCostCenter,
  getCostCenter,
  updateCostCenter,
  deleteCostCenter,
} from '../services/cost_center';
import costCenterActions, { Types } from '../actions/cost_center';

function* createCostCenterRequest(action) {
  try {
    const { payload } = action;
    const response = yield call(createCostCenter, payload);
    yield put(
      costCenterActions.createCostCenterSuccess({ data: response.data }),
    );
    yield put(costCenterActions.getCostCenterRequest(response.data));
    yield put(costCenterActions.resetFormFields());
    yield put(costCenterActions.closeCostCenterDrawer());
    successToast('Cost Centre Created');
  } catch (error) {
    yield put(costCenterActions.createCostCenterFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* getCostCenterRequest(action) {
  try {
    const { params } = action;
    const response = yield call(getCostCenter, params);
    yield put(costCenterActions.getCostCenterSuccess(response.data));
  } catch (error) {
    yield put(costCenterActions.getCostCenterFailure());
  }
}

function* updateCostCenterRequest(action) {
  try {
    const { params, payload } = action;
    const response = yield call(updateCostCenter, params, payload);
    successToast('Cost Centre Updated Successfully');
    yield put(
      costCenterActions.updateCostCenterSuccess({ data: response.data }),
    );
    yield put(costCenterActions.getCostCenterRequest(response.data));
    yield put(costCenterActions.closeCostCenterDrawer());
    yield put(costCenterActions.resetFormFields());
  } catch (error) {
    yield put(costCenterActions.updateCostCenterFailure());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* deleteCostCenterRequest(action) {
  try {
    const { params } = action;
    yield call(deleteCostCenter, params);
    yield put(costCenterActions.deleteCostCenterSuccess(params));
    yield put(costCenterActions.closeConfirmationModal());
    successToast('Cost Centre Deleted Successfully');
  } catch (error) {
    yield put(costCenterActions.deleteCostCenterFailure());
    yield put(costCenterActions.closeConfirmationModal());
    error?.response?.data?.error && errorToast(error.response.data.error);
  }
}

function* categoryWatcher() {
  yield takeLatest(Types.CREATE_COST_CENTER_REQUEST, createCostCenterRequest);
  yield takeLatest(Types.GET_COST_CENTER_REQUEST, getCostCenterRequest);
  yield takeLatest(Types.UPDATE_COST_CENTER_REQUEST, updateCostCenterRequest);
  yield takeLatest(Types.DELETE_COST_CENTER_REQUEST, deleteCostCenterRequest);
}

export default categoryWatcher;
